var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        {
          staticClass: "overlay",
          on: {
            click: function ($event) {
              if ($event.target !== $event.currentTarget) return null
              return _vm.$emit("close")
            },
          },
        },
        [
          _c("div", { staticClass: "modal" }, [
            _c("div", { staticClass: "modal-top" }, [
              _c("div", { staticClass: "success-icon" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "28",
                      height: "28",
                      viewBox: "0 0 16 16",
                      fill: "currentColor",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M13.485 1.929a.75.75 0 0 1 0 1.06l-7.778 7.778a.75.75 0 0 1-1.06 0L1.515 6.636a.75.75 0 1 1 1.06-1.06l2.657 2.657 7.248-7.248a.75.75 0 0 1 1.06 0z",
                      },
                    }),
                  ]
                ),
              ]),
              _c("h3", [_vm._v("Binding Successful!")]),
              _c("p", [
                _vm._v(
                  "\n        Your App has been linked to the " +
                    _vm._s(_vm.platformLabel) +
                    " store. You can now open the " +
                    _vm._s(_vm.platformLabel) +
                    "\n        plugin settings to verify the configuration.\n      "
                ),
              ]),
            ]),
            _c("div", { staticClass: "modal-body" }, [
              _c("div", { staticClass: "info-card" }, [
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v("App Name"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.appName || "—")),
                  ]),
                ]),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [_vm._v("App ID")]),
                  _c("span", { staticClass: "info-value mono" }, [
                    _vm._v(_vm._s(_vm.appId || "—")),
                  ]),
                ]),
                _c("div", { staticClass: "info-row" }, [
                  _c("span", { staticClass: "info-label" }, [
                    _vm._v(_vm._s(_vm.platformLabel) + " Store Name"),
                  ]),
                  _c("span", { staticClass: "info-value" }, [
                    _vm._v(_vm._s(_vm.storeName || "—")),
                  ]),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "modal-foot" }, [
              _c(
                "button",
                {
                  staticClass: "btn-green",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("open-settings")
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "16",
                        height: "16",
                        viewBox: "0 0 16 16",
                        fill: "currentColor",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M6.22 3.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L9.94 8 6.22 4.28a.75.75 0 0 1 0-1.06z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(
                    "\n        Open " +
                      _vm._s(_vm.platformLabel) +
                      " App Settings\n      "
                  ),
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn-ghost",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close")
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }